import type { VariantType, Options } from 'motion-v';

type MotionTransition = Options['transition'];
type Variants = Record<string, VariantType>;

const EASE_POWER2_OUT = [0.25, 0.46, 0.45, 0.94] as const;
const EASE_BACK_OUT = [0.175, 0.885, 0.32, 1.275] as const;

export const fadeUpVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

export const checkmarkVariants: Variants = {
    hidden: { scale: 0, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
};

export const successPillVariants: Variants = {
    hidden: { opacity: 0, y: 15, scale: 0.9 },
    visible: { opacity: 1, y: 0, scale: 1 },
};

export const quickTransition: MotionTransition = {
    duration: 0.4,
    ease: EASE_POWER2_OUT,
};

export const mediumTransition: MotionTransition = {
    duration: 0.5,
    ease: EASE_POWER2_OUT,
};

export const fieldStagger: MotionTransition = {
    staggerChildren: 0.08,
    delayChildren: 0.15,
};

export const successTextStagger: MotionTransition = {
    staggerChildren: 0.15,
    delayChildren: 0.4,
};

export const successPillStagger: MotionTransition = {
    staggerChildren: 0.12,
    delayChildren: 0.9,
};

export const heroLineTransition: MotionTransition = {
    ...mediumTransition,
    delay: 0.7,
};

export const heroSubtitleTransition: MotionTransition = {
    ...mediumTransition,
    delay: 0.85,
};

export const heroButtonTransition: MotionTransition = {
    ...mediumTransition,
    delay: 1.2,
};

export const checkmarkTransition: MotionTransition = {
    duration: 0.6,
    ease: EASE_BACK_OUT,
};

export const successPillTransition: MotionTransition = {
    duration: 0.4,
    ease: EASE_BACK_OUT,
};

export const successSummaryStagger: MotionTransition = {
    staggerChildren: 0.1,
    delayChildren: 0.7,
};

export const successActionTransition: MotionTransition = {
    ...mediumTransition,
    delay: 1.0,
};
